import { ThunkAction } from 'redux-thunk';
import { State as LoginState } from '@telstra-connect/login';
import {
    loadCompanyStart,
    loadCompanySuccess,
    loadCompanyError,
    updateCompanyNotStartAction,
} from '../actions/load-company-multi-cidn';
import { Http } from '@telstra-connect/utils';
import { ICompanyResponse } from '../state/company-multi-cidn';

export function loadCompanyMultiCidn(): ThunkAction<void, LoginState.ISignInState, void> {
    return (dispatch, getState) => {
        dispatch(loadCompanyStart());
        return Http.get<ICompanyResponse>({
            url: '/ccv/customers/Channel Care',
            state: getState(),
        }).then((result) => {
            const resultData: ICompanyResponse = result;
            dispatch(loadCompanySuccess(resultData));
        }).catch((error) => {
            dispatch(loadCompanyError('Error loading planned maintenance company'));
        });
    };
}

export function updateCompanyNotStart() {
    return (dispatch, getState) => {
        dispatch(updateCompanyNotStartAction());
        return getState();
    };
};
